const GroupStatus = {
  active: 'Active',
  forming: 'Forming',
  closed: 'Closed',
};

export const isActive = (status) => status === GroupStatus.active;

export default { isActive };



// WEBPACK FOOTER //
// ./containers/Group/status.js